/**
 * The 80 planned suburb pages from Phase2_20Cities_Website_Plan.xlsx (Dallas tab):
 * 10 suburbs × 8 products = 80 pages at `/dallas/{suburb}/{product}`.
 *
 * The `/dallas/$slug/$product` route is otherwise combinatorial (16 suburbs ×
 * ~38 products), which would create 600+ doorway pages. We restrict it to this
 * planned set; every other combo returns 404.
 *
 * ⚠️ Phase 2: each of these 80 pages still needs UNIQUE local content (the plan's
 * "Unique-Content Requirement") before `VITE_INDEXABLE` is turned on - otherwise
 * they read as scaled/templated content.
 */

/** The 10 suburbs the plan targets with product pages. */
export const suburbPageCitySlugs = [
  "plano",
  "irving",
  "garland",
  "frisco",
  "mckinney",
  "grand-prairie",
  "mesquite",
  "carrollton",
  "richardson",
  "denton",
] as const;

/** The 8 products the plan targets per suburb. */
export const suburbPageProductSlugs = [
  "business-line-of-credit",
  "working-capital-loans",
  "invoice-factoring",
  "accounts-receivable-financing",
  "unsecured-business-loans",
  "short-term-business-loans",
  "same-day-business-loans",
  "sba-loans",
] as const;

const citySet: ReadonlySet<string> = new Set(suburbPageCitySlugs);
const productSet: ReadonlySet<string> = new Set(suburbPageProductSlugs);

/** True if this `{city}/{product}` combo is one of the 80 planned suburb pages. */
export function isPlannedSuburbPage(citySlug: string, productSlug: string): boolean {
  return citySet.has(citySlug) && productSet.has(productSlug);
}

/** All 80 planned suburb-page paths (no trailing slash - router-normalized). */
export function suburbPagePaths(): string[] {
  const paths: string[] = [];
  for (const c of suburbPageCitySlugs) {
    for (const p of suburbPageProductSlugs) {
      paths.push(`/dallas/${c}/${p}`);
    }
  }
  return paths;
}
